import { FormConfig } from '../edit-create-form.interfaces';
import { ROOM_STATUS_SELECT_CONFIG } from '@shared/components/generic-select/generic-select.configs';

export const roomStatusHistoryFormConfig = (): FormConfig => {
  return {
    fields: [
      {
        key: 'roomId',
        label: 'Phòng',
        type: 'text',
        hidden: true,
        width: 'full',
      },
      {
        key: 'status',
        label: 'Trạng thái',
        type: 'select',
        required: true,
        width: 'half',
        config: { ...ROOM_STATUS_SELECT_CONFIG },
        placeholder: 'Chọn trạng thái phòng',
        customErrorMessage: 'Vui lòng chọn trạng thái'
      },
      {
        key: 'fromDate',
        label: 'Từ ngày',
        type: 'datepicker',
        required: true,
        width: 'half',
        datePickerMode: 'dateTime',
        placeholder: 'Chọn ngày giờ bắt đầu',
        customErrorMessage: 'Vui lòng chọn ngày giờ bắt đầu'
      },
      {
        key: 'reason',
        label: 'Lý do',
        type: 'text',
        required: true,
        width: 'full',
        placeholder: 'Nhập lý do thay đổi trạng thái',
        customErrorMessage: 'Vui lòng nhập lý do'
      },
      {
        key: 'note',
        label: 'Ghi chú',
        type: 'textarea',
        width: 'full',
        rows: 3,
        placeholder: 'Nhập ghi chú (tùy chọn)'
      }
    ]
  };
};
